module.exports = __webpack_public_path__ + "static/media/CTLA_9-356w.b2e729f3.jpg";